module.exports = __webpack_public_path__ + "static/media/icon_training_blue.31ba3b37.svg";